import { Box, Typography } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid2";
import { API_Q_MEDALS_IMAGE } from "../../../../constants/api";
import classes from "./MedalInfo.module.scss";
import AButtonGamePlay from "../AButtonGamePlay/AButtonGamePlay";
import { useMedalInfoLogic } from "./useMedalInfoLogic";

const MedalInfoMobile = ({
  medal = null,
  max_level,
  conditions,
  medal_complete = false,
}) => {
  const { isMedalComplete, MedalConditions, getImageStyles, getStars } =
    useMedalInfoLogic({ medal, max_level, conditions });

  return (
    <Box
      sx={{
        height: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "10px",
        paddingLeft: "15px",
        paddingRight: "15px",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Grid item para a imagem */}
        <Grid item size={{xs: 12 }}>
          <Box
            className={classes.BwModal}
            sx={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginLeft: { xs: "50px", sm: "90px" },
            }}
          >
            <img
              className={classes.Image}
              src={`${API_Q_MEDALS_IMAGE}/${medal.image}`}
              alt={medal.title}
              style={{
                ...getImageStyles(isMedalComplete, conditions),
                width: "100%",
                height: "auto",
                maxWidth: "170px",
              }}
            />
          </Box>
        </Grid>

        {/* Grid item para o conteúdo */}
        <Grid item size={{xs: 12}}>
          <Box
            sx={{
              textAlign: "left",
              padding: "10px",
              marginBottom: "20px",
              fontSize: "13px",
              color: "#4D4D4D",
            }}
          >
            <Typography
              dangerouslySetInnerHTML={{ __html: medal.description }}
              sx={{
                textAlign: "left",
                marginBottom: "20px",
                "& li": {
                  marginBottom: "8px",
                  listStyleType: "disc",
                  marginLeft: "20px",
                },
              }}
            />
            <Typography sx={{ textAlign: "left" }}>
              <Typography
                dangerouslySetInnerHTML={{ __html: medal.goals }}
                sx={{ marginBottom: "8px" }}
              />
              <MedalConditions
                conditions={medal.conditions}
                max_level={medal.max_level}
              />
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box className={classes.ColorModal} sx={{ marginTop: "-20px" }}>
        {getStars(max_level, medal.conditions)}
        <AButtonGamePlay sx={{ marginTop: "-10px" }} />
      </Box>
    </Box>
  );
};

export default MedalInfoMobile;
